var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user_list_page" },
    [
      _c("pageTitle"),
      _c("business-group", {
        ref: "businessGroup",
        attrs: {
          tableConfig: { ..._vm.tableConfig },
          formConfig: { ..._vm.formConfig },
        },
        scopedSlots: _vm._u([
          {
            key: "formSlot",
            fn: function (formSlot) {
              return [
                _c(
                  "a-form-item",
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["keyword"],
                          expression: "['keyword']",
                        },
                      ],
                      staticStyle: {
                        width: "200px",
                        "margin-right": "10px",
                        "vertical-align": "middle",
                      },
                      attrs: { placeholder: "请输入效果名称/上传者" },
                    }),
                  ],
                  1
                ),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-select",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["lightType"],
                            expression: "['lightType']",
                          },
                        ],
                        staticStyle: { width: "150px" },
                        attrs: { placeholder: "请选择效果类型" },
                      },
                      _vm._l(_vm.lightType, function (el) {
                        return _c(
                          "a-select-option",
                          { key: el.value, attrs: { value: el.value } },
                          [_vm._v(_vm._s(el.label))]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "lightType",
            fn: function (record) {
              return [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.createMaps(_vm.lightType, record.lightType)
                    ),
                  },
                }),
              ]
            },
          },
          {
            key: "effectType",
            fn: function (record) {
              return [
                record.effectType === "PICTURE"
                  ? _c("m-image", { attrs: { url: record.effectUrl } })
                  : _vm._e(),
                record.effectType === "VIDEO"
                  ? _c("mVideo", {
                      attrs: {
                        "img-url": record.videoCover,
                        "video-url": record.effectUrl,
                      },
                    })
                  : _vm._e(),
              ]
            },
          },
          {
            key: "action",
            fn: function (record) {
              return [
                _c(
                  "a-button",
                  {
                    attrs: { type: "link" },
                    on: { click: () => _vm.del(record) },
                  },
                  [_vm._v("删除")]
                ),
              ]
            },
          },
          {
            key: "avatar",
            fn: function (record) {
              return [
                _c(
                  "viewer",
                  { attrs: { images: [record.avatar] } },
                  [
                    _c("a-avatar", {
                      attrs: { size: "large", src: record.avatar },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "lightEffect",
            fn: function (record) {
              return [
                record.lightType === "WHITE_LIGHT"
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "亮度: " + _vm._s(record.brightness || 0) + " %"
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "色温: " + _vm._s(record.colorTemperature || 0) + " K"
                        ),
                      ]),
                      record.lightEffect === "COLOR_TEMPERATURE_PIECE"
                        ? _c("div", [
                            _c("p", [
                              _vm._v(
                                "CTO: " + _vm._s(record.cto || 0) + " CTO"
                              ),
                            ]),
                            _c("p", [
                              _vm._v(
                                "CTB: " + _vm._s(record.ctb || 0) + " CTB"
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                record.lightType === "COLORAMA"
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "亮度: " + _vm._s(record.brightness || 0) + " %"
                        ),
                      ]),
                      _c("p", [
                        _vm._v("CTB: " + _vm._s(record.ctb || 0) + " CTB"),
                      ]),
                      record.lightEffect === "COLOR_COORDINATE"
                        ? _c("div", [
                            _c("p", [
                              _vm._v(
                                "色坐标: " +
                                  _vm._s(record.xtAxis) +
                                  " " +
                                  _vm._s(record.ytAxis)
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ])
                  : _vm._e(),
                record.lightType === "LIGHT_EFFECT"
                  ? _c("div", [
                      _c("p", [
                        _vm._v(
                          "亮度: " + _vm._s(record.brightness || 0) + " %"
                        ),
                      ]),
                      _c("p", [
                        _vm._v("色相: " + _vm._s(record.hue || 0) + " °"),
                      ]),
                      _c("p", [
                        _vm._v(
                          "饱和: " + _vm._s(record.saturation || 0) + " %"
                        ),
                      ]),
                      _c("p", [
                        _vm._v(
                          "CTB: " + _vm._s(record.intensity || 0) + " CTB"
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c(
        "a-modal",
        {
          staticStyle: { "margin-bottom": "10px" },
          attrs: {
            visible: _vm.visibleChange,
            title: "删除理由",
            maskClosable: false,
          },
          on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
        },
        [
          _c("a-textarea", {
            attrs: {
              rows: 8,
              "auto-size": { minRows: 3, maxRows: 5 },
              placeholder: "请填写删除该条的理由",
            },
            model: {
              value: _vm.ly,
              callback: function ($$v) {
                _vm.ly = $$v
              },
              expression: "ly",
            },
          }),
          _c(
            "span",
            { staticClass: "modal-tips" },
            [
              _c("a-icon", { attrs: { type: "exclamation-circle" } }),
              _vm._v(" 用户会通过消息中心接收到已被移除精选广场"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }